// Pixel helpers.
//
// A pixel is [col, row, tag]. A tag is a literal '#rrggbb' color (props, outfits), or a body
// tag that the companion's skin colors: '@...' for the body, 'E' an eye, 'C' a closed eye.

import { env } from './core.js';

// The color of one pixel: a literal color, or a body tag that the companion's look resolves
// (see skins.js).
export const colorOf = (tag, c, r, now, look) => (tag[0] === '#' ? tag : look.color(tag, c, r, now));

// Parse ASCII art into pixels. '.' and ' ' are empty; legend maps characters to tags.
// (ox, oy) is the art's top-left cell in body coordinates.
export function sprite(art, legend, ox = 0, oy = 0) {
  const rows = art.replace(/^\n+|\n+\s*$/g, '').split('\n');
  const px = [];
  rows.forEach((line, r) => [...line].forEach((ch, c) => {
    if (ch === '.' || ch === ' ') return;
    const tag = legend[ch];
    if (tag) px.push([c + ox, r + oy, tag]);
  }));
  return px;
}

export const mirror = px => px.map(([c, r, t]) => [-1 - c, r, t]);
export const shift = (px, dc, dr) => px.map(([c, r, t]) => [c + dc, r + dr, t]);

// Draw pixels with their (0, 0) at screen point (x, y). look colors the body tags (null when
// there are only literal colors); tint(color) can recolor (for effects), but a see-through pixel
// ('#rrggbb00': a part a skin leaves out) stays see-through.
export function blit(px, x, y, s, now, look, tint, ctx = env.ctx) {
  const X = Math.round(x), Y = Math.round(y);
  for (const [c, r, tag] of px) {
    const col = colorOf(tag, c, r, now, look);
    ctx.fillStyle = tint && !(col.length === 9 && col.endsWith('00')) ? tint(col) : col;
    ctx.fillRect(X + c * s, Y + r * s, s, s);
  }
}

export function bounds(px) {
  let c0 = Infinity, c1 = -Infinity, r0 = Infinity, r1 = -Infinity;
  for (const [c, r] of px) { c0 = Math.min(c0, c); c1 = Math.max(c1, c); r0 = Math.min(r0, r); r1 = Math.max(r1, r); }
  return { c0, c1, r0, r1 };
}

// Bresenham line, for parachute strings and similar.
export function linePx(c0, r0, c1, r1, tag) {
  const px = [], dx = Math.abs(c1 - c0), sx = c0 < c1 ? 1 : -1, dy = -Math.abs(r1 - r0), sy = r0 < r1 ? 1 : -1;
  let err = dx + dy;
  for (let guard = 0; guard < 400; guard++) {
    px.push([c0, r0, tag]);
    if (c0 === c1 && r0 === r1) break;
    const e2 = 2 * err;
    if (e2 >= dy) { err += dy; c0 += sx; }
    if (e2 <= dx) { err += dx; r0 += sy; }
  }
  return px;
}
